$(function() {
	if (navigator.userAgent.match(/iPhone;/i) && navigator.userAgent.match(/AppleWebKit/i)) {
		$(document.body).addClass('ios-safari');
	}
});
